import React from 'react'
import Link from '../Link/Link'
import clsx from 'clsx'
import { makeStyles, Theme, createStyles } from '@material-ui/core'
import { prismicText } from '../Global/CMSText'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: theme.spacing(4),
      alignItems: 'center',
    },
    bottomLinks: {
      fontSize: theme.typography.pxToRem(10),
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(8),
      },
    },
  })
)

const BottomMenuLinks = ({ datas }) => {
  const classes = useStyles()

  return (
    datas?.length > 0 && (
      <div className={clsx(classes.row, 'product__bottom')}>
        {datas?.map((links, index) => {
          return (
            <React.Fragment key={index}>
              {links?.link?.url ? (
                <Link href={links?.link?.url}>
                  <a
                    href={links?.link?.url}
                    target={links?.link?.target ? links?.link?.target : '_self'}
                    className={clsx(
                      'product__bottom-item',
                      'product__bottom-link',
                      classes.bottomLinks
                    )}
                  >
                    {prismicText(links?.name)}
                  </a>
                </Link>
              ) : (
                <div
                  className={clsx('product__bottom-item', classes.bottomLinks)}
                >
                  {prismicText(links?.name)}
                </div>
              )}
              {index !== datas?.length - 1 && <div>|</div>}
            </React.Fragment>
          )
        })}
      </div>
    )
  )
}

export default BottomMenuLinks
